document.addEventListener("DOMContentLoaded", function () {
    const productNames = document.querySelectorAll('.n8k95w1');
    productNames.forEach(function (productNameElement) {
        const productName = productNameElement.innerText;
        
        const productUrl = `/products/${productName.replace(/\s+/g, '-').toLowerCase()}`;

        const productLink = document.createElement('a');
        productLink.href = productUrl;
        productLink.innerText = productName;

        productNameElement.innerHTML = '';
        productNameElement.appendChild(productLink);
    });
});
